// extracted by mini-css-extract-plugin
export default {"textContent":"HomePage_textContent__RAUME","highlight":"HomePage_highlight__Mb0P3","imageContent":"HomePage_imageContent__E99n4","imageImg":"HomePage_imageImg__o+p1g"};